import httpService from '@/core/http-service'

function getUpcomingTasks() {
  return httpService.get('rpc/calendar/getUpcomingTasks')
}

export default { getUpcomingTasks }
